<template>
    <transition name="fade">
        <div ref="options" class="k-popover" v-if="showPopover">
            <div class="scroll-wrap" id="scroll-wrap">
                <ul class="k-ul" id="k-ul">
                    <li v-for="item in val" :class="{on: item.id === selected}" :key="item.id" @click="selectOption(item)">{{item.val}}</li>
                </ul>
            </div>
        </div>
    </transition>
</template>

<script>

    export default {
        name: 'k-option',
        props: [
            'val',
            'pos',
            'size',
            'selected'
        ],
        data (){
            return {
                showPopover: false
            };
        },
        methods: {
            computeStyle (){
                /**
                 * 初始化popover的宽度和位置
                 */
                var popover = this.$refs.options;
                popover.style.width = this.size.width + 'px';
                popover.style.top = this.pos.top + this.size.height + 4 + 'px';
                popover.style.left = this.pos.left + 'px';
                document.body.appendChild(popover);
                /**
                 * 修改scroll-wrap的样式以清除滚动框
                 */
                this.$nextTick(function(){
                    // var scrollWrap = document.getElementById('scroll-wrap'),
                    //     kUl = document.getElementById('k-ul');
                    // scrollWrap.style.marginRight = kUl.offsetWidth - scrollWrap.offsetWidth + 'px'
                    // scrollWrap.style.marginBottom = kUl.offsetWidth - scrollWrap.offsetWidth + 'px'
                });
                
            },
            attachClick (){
                var vm = this;
                document.onclick = function(e){
                    var cName = e.target.parentNode && e.target.parentNode.className || '';                    
                    if(typeof cName === 'string'){
                        if(cName !== 'k-ul' && cName !== 'scroll-wrap' && cName !== 'k-popover'){
                            vm.$emit('closePopover');
                        }
                    }
                };
            },
            selectOption (item){
                this.$emit('closePopover', item);
            }
        },        
        created (){       
            this.showPopover = true;
        },
        mounted (){
            this.computeStyle();
            this.attachClick();
        },
        beforeDestroy(){
           this.$refs.options.remove();
        }
    };
</script>

<style lang="scss" scoped>
    .k-popover {
        position: absolute;
        top:0;
        left: 0;
        max-height: 1.2rem;
        border-radius: .2rem;
        background-color: #fff;
        box-shadow: 0 .06rem .1rem rgba(0,0,0,.2) ;
        box-sizing: border-box;
        overflow: hidden;
    }
    .scroll-wrap {
        max-height: 1.2rem;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .k-ul {
        margin: 0;
        padding: 0;
        background-color: #fff;
        box-sizing: border-box;
        li {
            position: relative;
            padding: 0 .12rem;
            height: .4rem;
            color: #444444;
            line-height: .4rem;
            font-size: .12rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            list-style-type: none;
            box-sizing: border-box;
            cursor: pointer;
            &.on {
                color: #50BBE5;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
